import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {SecurityService} from '../../shared/security.service';
import {GroupGuard} from '../../shared/group.guard';

@Injectable()
export class ServiceLogGuard extends GroupGuard {
 
  constructor(private secSvc: SecurityService, router: Router) {
    super(secSvc, router);
    this.validate = () => this.secSvc.isServiceLogAdmin();
  }

}
